<div style="height: 100vh;width: 100%;" class="d-flex flex-column align-items-center justify-content-between ">
    <app-admin-header style="width: 100%;" [header]="header" [links]="links" [breadcrumbs]="breadcrumbs"
        [stats]="stats" [queryParams]="queryParams" ></app-admin-header>



    <app-assessment-result-module [assessmentIds]="assessmentIds" ></app-assessment-result-module>

    <app-footer style="width: 100%;"></app-footer>


</div>
